var map = {
	"./": [
		689,
		689
	],
	"./bsc": [
		66751,
		6751
	],
	"./bsc.ts": [
		66751,
		6751
	],
	"./bscTestnet": [
		36453,
		6453
	],
	"./bscTestnet.ts": [
		36453,
		6453
	],
	"./goerli": [
		55423,
		5423
	],
	"./goerli.ts": [
		55423,
		5423
	],
	"./index": [
		689,
		689
	],
	"./index.ts": [
		689,
		689
	],
	"./polygonZkEVM": [
		70444,
		444
	],
	"./polygonZkEVM.ts": [
		70444,
		444
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 24615;
module.exports = webpackAsyncContext;